import { useState } from "react";
import { syncN8nAudiosURL } from "../../utils/ConstantsURL";

export const useSyncN8nAudios = () => {
  const [loadingSync, setLoadingSync] = useState(false);

  const syncAudios = async () => {
    try {
      setLoadingSync(true);

      const response = await fetch(syncN8nAudiosURL(), {
        method: "POST",
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Error al sincronizar audios");
      }

      return { success: true, message: result.message };
    } catch (error) {
      return { success: false, message: error.message };
    } finally {
      setLoadingSync(false);
    }
  };

  return { syncAudios, loadingSync };
};